import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

async function getBlockOutRanges({ organisationId, branchId, page, limit }) {
  const queryParams = new URLSearchParams({
    organisationId,
    page,
  });
  if (branchId) queryParams.set('branchId', branchId);
  if (limit) queryParams.set('limit', limit);

  const queryString = `?${queryParams.toString()}`;
  const response = await axiosPrivate.get(
    `/v3/pharmacist/availability-block-out-ranges${queryString}`
  );

  return response.data;
}

export default function useGetBlockOutRanges({ organisationId, branchId, page = 1, limit }) {
  return useQuery({
    queryKey: ['block-out-ranges', organisationId, branchId, page, limit],
    queryFn: () => getBlockOutRanges({ organisationId, branchId, page, limit }),
    enabled: Boolean(organisationId),
    meta: { errorMessage: 'Failed to load block-out ranges' },
  });
}
